"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./TextArea.scss");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const TextArea = _ref => {
  let {
    label,
    value,
    inputChange,
    name
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-form-item"
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "ter-form-item__label"
  }, label), /*#__PURE__*/_react.default.createElement("textarea", {
    defaultValue: value,
    onChange: e => inputChange(e, name),
    name: name,
    className: "ter-textarea"
  }));
};
var _default = TextArea;
exports.default = _default;
TextArea.propTypes = {
  label: _propTypes.default.string.isRequired,
  inputChange: _propTypes.default.func.isRequired,
  value: _propTypes.default.string.isRequired,
  name: _propTypes.default.string
};